module.exports = __webpack_public_path__ + "images/481c77cec07c0afe28ca7667059ddb93.png";